"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUpRequestDTOBlank = exports.SignUpRequestDTOSchema = void 0;
var zod_1 = require("zod");
var Password_1 = require("./Password");
var User_1 = require("./User");
exports.SignUpRequestDTOSchema = zod_1.z.object({
    // phone
    firstName: zod_1.z.string({ required_error: 'First Name is required' }).trim().min(1, 'First Name is required'),
    lastName: zod_1.z.string({ required_error: 'Last Name is required' }).trim().min(1, 'Last Name is required'),
    email: zod_1.z
        .string({ required_error: 'Email is required' })
        .trim()
        .min(1, 'Email is required')
        .email('Invalid Email Address'),
    phone: zod_1.z
        .string({ required_error: 'Phone Number is required' })
        .trim()
        .min(6, 'Phone Number must contain at least 6 letters'),
    dateOfBirth: zod_1.z
        .string({
        required_error: 'Your birthday is required',
        invalid_type_error: 'Your birthday must be a valid date string',
    })
        .min(1, 'Your birthday is required'),
    membershipType: zod_1.z
        .string({ required_error: 'Type of Membership is required' })
        .refine(function (value) { return value !== 'placeholder'; }, 'Please select a Type of Membership'), // TODO: add mongoose ObjectId validation,
    // position: z
    //   .string({ required_error: 'Position is required' })
    //   .refine((value) => value !== 'placeholder', 'Please select a Position'), // TODO: add mongoose ObjectId validation
    termsAndConditionsAccepted: zod_1.z.boolean().refine(function (value) { return value; }, 'Please accept the terms and conditions'),
    password: Password_1.PasswordSchema, // z.string({ required_error: 'Password is required' }).trim().min(1, 'Password is required'),
    isActive: zod_1.z.boolean().optional(),
    userRole: zod_1.z.nativeEnum(User_1.UserRole).optional(),
});
exports.SignUpRequestDTOBlank = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    dateOfBirth: '',
    membershipType: 'placeholder',
    // position: 'placeholder',
    termsAndConditionsAccepted: false,
    password: '',
};
//# sourceMappingURL=SignUpRequest.js.map